import React from 'react'
import VisDiv from '../frontend_components/VisDiv'

/**
 * ProgressHeader is a component that renders a horizontal bar with
 * clickable items. Each item represents a step in a process and
 * clicking on it will update the progressTab state.
 * #core
 * @param {Object} progressTab - The current step in the process
 * @param {Function} setProgressTab - A function to update the progressTab state
 * @param {Array} progressList - A list of steps in the process
 * 
 * @returns {JSX.Element} A JSX component that renders the progress bar
 */
export const ProgressHeader = ({progressTab, setProgressTab, progressList}) => {
  
    return (
      
      <div style={{
        display:"flex", 
        cursor:"pointer", 
        minHeight:"60px", 
        backgroundColor:"white", 
        //justifyContent:"center", 
        alignItems:"center",
        marginTop:"15px", 
        marginBottom:"15px",
        overflow:"auto"
        }}>
          {progressList?.map?.((item, index)=>{
               const activeBackground = progressTab?.description == item?.description ? {backgroundColor:"#CCC"} : {}
              return(
              <VisDiv key={index} onClick={()=>{setProgressTab({...item, index})}} style={{
                  display:"flex", 
                  justifyContent:"center", 
                  alignItems:"center", 
                  minHeight:"60px", 
                  height:"100%", 
                  minWidth:"140px",
                  ...activeBackground
                  }}>
                  <h5 style={{padding:"10px"}}>{`${index+1}.${item?.description}`}</h5>
               </VisDiv>
              )
          })}
  
      </div>
    )
  }
